import React from 'react'
import PropTypes from 'prop-types'

const HomeIcon = ({ size = '24', color = '#101820' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.11 1.20888L12.797 2.80381V2.80074L19.6537 9.28514L19.6542 9.28555C19.817 9.43937 19.9468 9.6248 20.0355 9.83049C20.1241 10.0361 20.1699 10.2576 20.17 10.4815C20.17 10.4816 20.17 10.4817 20.17 10.4818V20.3079C20.17 20.7445 19.9966 21.1633 19.6878 21.472C19.3791 21.7807 18.9604 21.9542 18.5238 21.9542H15.8775C15.4409 21.9542 15.0222 21.7807 14.7134 21.472C14.4047 21.1633 14.2313 20.7445 14.2313 20.3079V15.8975C14.2313 15.3984 14.033 14.9196 13.68 14.5667C13.327 14.2137 12.8483 14.0154 12.3492 14.0154H8.82084C8.32168 14.0154 7.84297 14.2137 7.49001 14.5667C7.13705 14.9196 6.93876 15.3984 6.93876 15.8975V20.3079C6.93876 20.7445 6.76531 21.1633 6.45658 21.472C6.14785 21.7807 5.72912 21.9542 5.2925 21.9542H2.64625C2.20983 21.9542 1.79126 21.7809 1.48257 21.4724L0.775694 22.1797L1.48256 21.4724C1.17394 21.164 1.00038 20.7457 1 20.3093L1 10.4833L1 10.4823C0.999779 10.2582 1.04532 10.0364 1.13383 9.8305C1.22233 9.62463 1.35193 9.43899 1.5147 9.28495C1.51471 9.28494 1.51472 9.28493 1.51473 9.28492L10.0599 1.209L10.06 1.20888C10.2019 1.07474 10.3898 1 10.585 1C10.7803 1 10.9681 1.07474 11.11 1.20888Z"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  )
}

export default React.memo(HomeIcon)

HomeIcon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
}
